import { makeAutoObservable, action, computed, toJS, extendObservable, set } from 'mobx';
import tableOptions from 'pages/wineLoversActivities/config/config';
import domainData from 'store/domainStore';
import { getInitialParams, saveParamsToStorage } from './common/filterUtils';

const STORAGE_KEY = 'wine_lovers_activities_filter_params';

// Default filter parameters
const defaultFilterParams = {
  params: {
    sort: {
      field: 'activity_timestamp',
      order: 'desc',
    },
    filter: {},
    limit: 100,
    skip: 0,
    search: {
      value: '',
      fields: [],
    },
  },
};

class WineLoversActivities {
  getDefaultStoreProps = () => ({
    wineLoversActivities: {
      count: 0,
      data: [],
    },
    filterData: defaultFilterParams,
  });

  constructor() {
    makeAutoObservable(this);
    extendObservable(this, { ...this.getDefaultStoreProps() });
  }

  @action
  reset() {
    set(this, this.getDefaultStoreProps());
  }

  @action
  setStoreWineLoversActivities(newData) {
    this.wineLoversActivities.data = [];
    newData.data.forEach(this.addStoreWineLoversActivities);
    this.wineLoversActivities.count = newData.count;
  }

  @action
  addStoreWineLoversActivities = element => {
    this.wineLoversActivities.data.push(element);
  };

  @action
  setFilter(filter) {
    this.filterData = filter;
    // Save to localStorage using common utility, but exclude search
    if (filter?.params) {
      const { search: _search, ...paramsWithoutSearch } = filter.params;
      const filterToSave = {
        ...filter,
        params: paramsWithoutSearch,
      };
      saveParamsToStorage(STORAGE_KEY, filterToSave);
    }
  }

  @action
  resetFilters() {
    this.setFilter(defaultFilterParams);
  }

  // Get default filter parameters using common utility with validation
  getCurrentFilterParams = (urlParams = {}) => {
    const isUserSuperAdmin = domainData.userIsSuperAdmin();
    const subscriptionAccess = domainData.getSubscriptionAllAccess();
    const userContext = { isUserSuperAdmin, subscriptionAccess };

    return getInitialParams(
      STORAGE_KEY,
      defaultFilterParams,
      tableOptions.wineLoversActivities,
      userContext,
      urlParams,
    );
  };

  @computed
  get filter() {
    const filterToJS = toJS(this.filterData);
    return filterToJS;
  }
}

export default new WineLoversActivities();
